module.exports = __webpack_public_path__ + "42071989e7f73fb4c5b7f2d311bd6cc7.png";